import { API_URL } from '../config/connect';

export async function getCategoryCharacteristics(categoryId) {
    if (!categoryId) return [];
    try {
        const response = await fetch(`${API_URL}/api/v1/categories/${categoryId}/characteristics`);
        if (!response.ok) return [];
        return response.json();
    } catch {
        return [];
    }
}
